import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';


import Lightbox from "yet-another-react-lightbox";
// eslint-disable-next-line import/no-unresolved
import "yet-another-react-lightbox/styles.css";
// eslint-disable-next-line import/no-unresolved
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
// eslint-disable-next-line import/no-unresolved
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
// eslint-disable-next-line import/no-unresolved
// import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
// eslint-disable-next-line import/no-unresolved
import Zoom from "yet-another-react-lightbox/plugins/zoom";
// eslint-disable-next-line import/no-unresolved
import "yet-another-react-lightbox/plugins/thumbnails.css";

import AppLayout from '../../layouts/app/AppLayout';
import AppIcons from '../../assets/images/icons';
import './custom.scss';
import CommentForm from '../../components/commentForm/commentForm';
import S3ImageViewerWithFallback from '../../components/awsS3ImageViewer/ImgViewerWithFallback';
import RichTextViewer from '../../components/rich-text-editor/TextViewer';
import { translateThis } from '../../helpers/language.helper';
import SVGIcons from '../../assets/images/icons/svgIcons';
// import CommentSection from './commentSection';




const IndividualArticles = () => {
    // custom home functions here
    const pageName = "Articles";
    const location = useLocation();
    const selectedArticle = location.state?.element || location.state?.latestArticle || location.state?.singleArticle || {};
    const [index, setIndex] = useState();
    const [selectedPhoto, setSelectedPhoto] = useState([])


    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString('en-US', {
            // weekday: 'long', hour: '2-digit', minute: '2-digit',second: '2-digit',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    };
    useEffect(() => {
        if (selectedArticle) {
            setSelectedPhoto(selectedArticle?.image)
        }
    }, []);

    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper individual-article-wrapper f-wrp">
                <div className='article-main-wrp f-wrp'>
                    <div className='article-main-container f-wrp'>
                        <div className='article-main-block f-wrp'>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className='article-list-wrp f-wrp'>
                                        <div className='article-list-box f-wrp'>
                                            <span className='article-img'>
                                                <button className='image-popup-btn' type='button'
                                                    onClick={() => {
                                                        setIndex(1)
                                                    }}>
                                                    <S3ImageViewerWithFallback key={`file-${selectedArticle.id}`} fileKey={selectedArticle.image} />
                                                </button>
                                            </span>

                                            {selectedPhoto && <Lightbox
                                                slides={selectedPhoto}
                                                render={{
                                                    slide: ({ slide }) => <S3ImageViewerWithFallback isShowRetry key={`file-${slide.src}`} fileKey={selectedArticle.image} />,
                                                }}
                                                open={index >= 0}
                                                index={index}
                                                close={() => setIndex(-1)}
                                                plugins={[Fullscreen, Slideshow, Zoom]}
                                                controller={{ closeOnBackdropClick: 'true' }}

                                            />}

                                            <div className='breadcrumb-list-wrp f-wrp'>
                                                <ul>
                                                    <li><Link to={'/'}>{translateThis('Home')} <SVGIcons.ChevronRightIcon /></Link></li>
                                                    <li><Link to={'/latest-articles'}>{translateThis('Latest articles')} <SVGIcons.ChevronRightIcon /></Link></li>
                                                    <li><span>{selectedArticle.title}</span></li>
                                                </ul>
                                            </div>
                                            <div className='article-detail-box f-wrp'>
                                                <h4>{selectedArticle.title}</h4>
                                                <RichTextViewer richText={selectedArticle?.description} />
                                                <div className='auth-box f-wrp'>
                                                    <span className='icon-img'><img src={selectedArticle.authIcon ? selectedArticle.authIcon : AppIcons.auther} alt={selectedArticle.author} /></span>
                                                    <div className='auth-detail'>
                                                        <p>{selectedArticle.author}</p>
                                                        <span>{formatDate(selectedArticle.createdAt)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='comment-form-wrp f-wrp'>
                                            {/* <CommentSection /> */}
                                            <CommentForm />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default IndividualArticles;